import pdf from '@STYLES/exports/pdf.module.scss';

import extractCSSVars from './helpers/extractCSSVars';

const PDF = extractCSSVars<number>(pdf, (a) => +a) as Readonly<Constant.PDF>;

export default PDF;
